import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ImmutableProptypes from 'react-immutable-proptypes'
import Modal from 'react-modal'
import moment from 'moment'

import { getNotesReceived, closeCollabNote, updateCollabNote } from '_modules/collaboration/actions'

import ListCard from './list-card'
import NoteDetails from './note-details'
// import InviteForm from './invite-form'
// import NoteForm from './note-form'
import styles from './styles.css'

Modal.setAppElement('body')

const mapStateToProps = ({ settings, user, collab }) => ({
  settings,
  user,
  collab,
})

const mapDispatchToProps = {
  getNotesReceived,
  closeCollabNote,
  updateCollabNote,
}

class QueuePanel extends Component {
  static propTypes = {
    user: ImmutableProptypes.map,
    collab: ImmutableProptypes.map,
    settings: ImmutableProptypes.map,
    getNotesReceived: PropTypes.func.isRequired,
    closeCollabNote: PropTypes.func.isRequired,
    updateCollabNote: PropTypes.func.isRequired,
  }

  static defaultProps = {
    user: new Map(),
    settings: new Map(),
    collab: new Map(),
  }

  state = {
    modalIsOpen: false,
    showResolved: false,
    receivedNotes: [],
    selectedNoteId: '',
  }

  componentWillMount() {
    this.callApis()
    this.getState(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.getState(nextProps)
  }

  getState = props => {
    const receivedNotes = props.collab
      .get('notesReceived')
      .toArray()
      .sort((a, b) => {
        if (moment(a.createdAt).isBefore(moment(b.createdAt))) return -1
        return 1
      })

    this.setState({ receivedNotes })
  }

  callApis = () => {
    this.props.getNotesReceived()
  }

  toggleShowResolved = () => {
    this.setState({
      showResolved: !this.state.showResolved,
    })
  }

  onExpandCard = id => {
    this.setState({
      modalIsOpen: true,
      selectedNoteId: id,
    })
  }

  onOpenedNote = payload => {
    this.props.updateCollabNote(payload)
  }

  onResolveNote = id => {
    const { selectedNoteId } = this.state
    let noteId = id
    if (!id) noteId = selectedNoteId
    this.props.closeCollabNote({ noteId })
  }

  onReopenNote = payload => {
    this.props.updateCollabNote(payload).then(this.callApis)
  }

  afterOpenModal = () => {
    // focus form input
  }

  closeModal = () =>
    this.setState({
      modalIsOpen: false,
      selectedNoteId: '',
    })

  renderCard = card => {
    if (card.fromUser) {
      return (
        <ListCard
          key={card._id}
          id={card._id}
          name={`${card.fromUser.name.first} ${card.fromUser.name.last}`}
          email={card.fromUser.email}
          status={card.fromUser.status}
          noteStatus={card.noteStatus}
          sentDate={card.createdAt}
          subject={card.subject}
          onExpandCard={this.onExpandCard}
          onResolveCard={this.onResolveNote}
        />
      )
    }
  }

  render() {
    const { receivedNotes, selectedNoteId, showResolved } = this.state
    const shownNote = receivedNotes.find(n => n._id === selectedNoteId)
    const unresolvedNotes = receivedNotes.filter(x => x.noteStatus < 3)
    const resolvedNotes = receivedNotes.filter(x => x.noteStatus === 3)

    const noUnresolved = unresolvedNotes.length === 0

    return (
      <div className={styles.container}>
        <div style={{ flex: 0.9, overflowY: 'scroll' }}>
          {noUnresolved ? (
            <div style={{ color: 'rgba(255,255,255,0.5)', padding: 30, fontSize: 15 }}>
              No unresolved messages.
            </div>
          ) : (
            unresolvedNotes.map(this.renderCard)
          )}
          {showResolved && (
            <div style={{ display: 'flex', flexDirection: 'column', paddingTop: 10 }}>
              <div style={{ color: 'white', fontSize: 16, alignSelf: 'center' }}>Resolved</div>
              {resolvedNotes.map(this.renderCard)}
            </div>
          )}
        </div>
        <div style={{ flex: 0.1 }}>
          <button className={styles.button} onClick={this.callApis}>
            Refresh
          </button>
          <button className={styles.button} onClick={this.toggleShowResolved}>
            {showResolved ? 'Show Open' : 'Show Resolved'}
          </button>
        </div>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          className={styles.modal}
          overlayClassName={styles.overlay}
          shouldCloseOnOverlayClick
        >
          {shownNote && (
            <NoteDetails
              noteId={shownNote._id}
              subject={shownNote.subject}
              urgencyType={shownNote.urgencyType}
              preferredResponse={shownNote.preferredResponse}
              status={shownNote.noteStatus}
              message={shownNote.message}
              sentDate={shownNote.createdAt}
              fromUser={`${shownNote.fromUser.name.first} ${shownNote.fromUser.name.last} <${
                shownNote.fromUser.email
              }>`}
              onOpened={this.onOpenedNote}
              onResolve={this.onResolveNote}
              onReopen={this.onReopenNote}
              onCancel={this.closeModal}
            />
          )}
        </Modal>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QueuePanel)



// WEBPACK FOOTER //
// ./src/views/collaborate/queue-panel/index.js